import { useState } from "react";
import CustomModal from "../CustomModal/CustomModal";
import styles from "./SuggestFeature.module.css";
import { Button, TextField } from "@shopify/polaris";
import { endPoints, postData } from "../../utilities/networkCalls";

const SuggestFeature = ({ bundleType }: { bundleType: string | number }) => {
    const [openSuggestFeatureModal, setOpenSuggestFeatureModal] = useState(false);

    return (
        <div className={styles.suggest_feature}>
            <p>Are we missing any feature you are looking for?</p>
            {/* <p
                className={styles.suggest_feature_link}
                onClick={() => {
                    setOpenSuggestFeatureModal(true);
                }}
                >
                Suggest feature here{" "}
            </p> */}
            <Button
                onClick={() => {
                    setOpenSuggestFeatureModal(true);
                }}
            >
                Suggest feature here{" "}
            </Button>
            <SuggestFeatureModal
                openSuggestFeatureModal={openSuggestFeatureModal}
                setOpenSuggestFeatureModal={setOpenSuggestFeatureModal}
                bundleType={bundleType}
            />
        </div>
    );
};

const SuggestFeatureModal = ({ openSuggestFeatureModal, setOpenSuggestFeatureModal, bundleType }: any) => {
    const [featureText, setFeatureText] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [submitFeatureLoading, setSubmitFeatureLoading] = useState(false);

    const handleClose = () => {
        setOpenSuggestFeatureModal(false);
        setErrorMessage("");
        setFeatureText("");
    };

    const handleSubmitFeatureRequest = async () => {
        if (featureText.length <= 0) {
            setErrorMessage("Message is required!");
            return;
        }

        setSubmitFeatureLoading(true);
        const res = await postData({
            url: endPoints.suggestFeature,
            payload: {
                type: bundleType,
                message: featureText,
            },
        });
        if (res.status == 200) {
            setFeatureText("");
            shopify.toast.show("Thank you for your suggestion", {
                isError: false,
            });
            setErrorMessage("");
            setOpenSuggestFeatureModal(false);
            setSubmitFeatureLoading(false);
        } else {
            setFeatureText("");
            setErrorMessage("");
            setSubmitFeatureLoading(false);
        }
    };

    return (
        <CustomModal
            title={"New Feature Request"}
            open={openSuggestFeatureModal}
            onClose={handleClose}
            children={
                <div className={styles.suggest_feature_modal_wrapper}>
                    <h4>Explain the missing feature in few words</h4>

                    <TextField
                        label="Feature Request"
                        labelHidden
                        value={featureText}
                        onChange={(e) => {
                            setFeatureText(e);
                        }}
                        error={featureText.length === 0 && errorMessage}
                        focused
                        autoComplete="off"
                        placeholder={"Type here..."}
                        multiline={4}
                        showCharacterCount
                        maxLength={200}
                    />
                </div>
            }
            primaryAction={{
                content: "Submit",
                onAction: handleSubmitFeatureRequest,
                loading: submitFeatureLoading,
                disabled: submitFeatureLoading,
            }}
        />
    );
};

export default SuggestFeature;
